
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWind1 as ObiWind1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-1.js';
 
 
 

 
 export const ObiWind1 = createComponent({
   react: React,
   tagName: 'obi-wind-1',
   elementClass: ObiWind1Element,
   events: {
     
   }
  });
 
 